/**
 * 共享坐标解析（度分秒 / 度分 / 纯数字 / 智能 lat-lng 对）
 * CoordinateTool 与 RescuePush 共用，避免两处复制。
 */

/**
 * 解析单段坐标字符串（度分秒 / 度分 / 纯数字）
 */
export function parseCoordinate(coordStr) {
  const str = coordStr.trim();

  if (str.includes('°')) {
    const match = str.match(/(\d+)°(\d+)'([\d.]+)"/);
    if (match) {
      const degrees = parseFloat(match[1]);
      const minutes = parseFloat(match[2]);
      const seconds = parseFloat(match[3]);
      return degrees + minutes / 60 + seconds / 3600;
    }

    const match2 = str.match(/(\d+)°([\d.]+)'/);
    if (match2) {
      const degrees = parseFloat(match2[1]);
      const minutes = parseFloat(match2[2]);
      return degrees + minutes / 60;
    }
  }

  return parseFloat(str);
}

/**
 * 智能识别「纬度,经度」或「经度,纬度」组合字符串
 * 支持中英文逗号、顿号、空白分隔
 * @returns {{ lat: number, lng: number } | null}
 */
export function parseCoordinateString(coordStr) {
  if (!coordStr) return null;

  // 中英文逗号 / 顿号 / 分号 / 空白均可作分隔；先归一再判 lat,lng 或 lng,lat
  let normalized = String(coordStr)
    .replace(/[，、；;]/g, ',')
    .replace(/\u00a0/g, ' ')
    .trim();

  if (!normalized.includes(',')) {
    const spaced = normalized.match(/^(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)$/);
    if (spaced) {
      normalized = `${spaced[1]},${spaced[2]}`;
    }
  }

  const cleanStr = normalized.replace(/\s+/g, '');

  if (cleanStr.includes(',')) {
    const parts = cleanStr.split(',').map((s) => s.trim()).filter(Boolean);
    if (parts.length >= 2) {
      const val1 = parseFloat(parts[0]);
      const val2 = parseFloat(parts[1]);

      if (isNaN(val1) || isNaN(val2)) {
        return null;
      }

      if (val1 >= -90 && val1 <= 90 && val2 >= -180 && val2 <= 180) {
        return { lat: val1, lng: val2 };
      }
      if (val2 >= -90 && val2 <= 90 && val1 >= -180 && val1 <= 180) {
        return { lat: val2, lng: val1 };
      }
      if (val1 >= 18 && val1 <= 54 && val2 >= 73 && val2 <= 135) {
        return { lat: val1, lng: val2 };
      }
      if (val2 >= 18 && val2 <= 54 && val1 >= 73 && val1 <= 135) {
        return { lat: val2, lng: val1 };
      }
    }
  }

  return null;
}


/**
 * 从后端地图链接解析结果中取 WGS84
 */
export function pickWgs84FromParseResult(data) {
  if (!data) return null;
  const c = data.coordinates || {};
  const all = data.allCoordinates || {};
  const candidates = [
    c.wgs84,
    all.wgs84,
    data.system === 'WGS84' ? { lat: c.lat, lng: c.lng } : null,
    typeof c.lat === 'number' && typeof c.lng === 'number' ? { lat: c.lat, lng: c.lng } : null
  ];
  for (const item of candidates) {
    if (item && Number.isFinite(item.lat) && Number.isFinite(item.lng)) {
      return { lat: item.lat, lng: item.lng, note: data.note || '', name: data.name || '' };
    }
  }
  return null;
}
